var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8359 8.70698C17.2265 8.31645 17.2265 7.68328 16.8359 7.29276C16.4454 6.90224 15.8122 6.90225 15.4217 7.29278L12.0644 10.6502L8.70712 7.29278C8.3166 6.90225 7.68343 6.90224 7.2929 7.29276C6.90237 7.68328 6.90237 8.31645 7.29288 8.70698L10.6502 12.0644L7.29288 15.4218C6.90237 15.8123 6.90237 16.4455 7.2929 16.836C7.68343 17.2265 8.3166 17.2265 8.70712 16.836L12.0644 13.4786L15.4217 16.836C15.8122 17.2265 16.4454 17.2265 16.8359 16.836C17.2265 16.4455 17.2265 15.8123 16.8359 15.4218L13.4786 12.0644L16.8359 8.70698Z",
    fill: "#9FA5AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.0f88554a999fd2056f87bb576e68f091.svg";
export { ForwardRef as ReactComponent };